import ProfileFolderCard from './ProfileFolderCard';
import ProfileFolderCardContainer from './ProfileFolderCard.container';

export default ProfileFolderCardContainer(ProfileFolderCard);
